import assert from 'minimalistic-assert'

import { FIELDS, PRIORITY_LEVELS, VALIDATION_TYPES } from '../constants.js'

const createValidator = ({
  id,
  shouldValidate,
  isValid,
  type = VALIDATION_TYPES.ERROR,
  priority = PRIORITY_LEVELS.BASE,
  field = FIELDS.AMOUNT,
  getMessage,
  ...rest
}) => {
  assert(id, 'id required')
  assert(shouldValidate, `${id}: shouldValidate required`)
  assert(isValid, `${id}: isValid required`)
  assert(type !== undefined, `${id}: type required`)
  assert(priority !== undefined, `${id}: priority required`)
  assert(field !== undefined, `${id}: field required`)
  assert(getMessage, `${id}: getMessage required`)

  return {
    id,
    shouldValidate,
    isValid,
    getMessage,
    type,
    priority,
    field,
    ...rest,
  }
}

export default createValidator
